import React, { FunctionComponent, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { SearchableSelect, SearchableSelectOption } from '../FormFields/SearchableSelect';

export interface OutletSearchComboboxProps {
  allowedCompanies: Array<DealerIntegration.Components.Schemas.MilesBrokerCompaniesData>;
  onSelectedCompanyChange: (value: DealerIntegration.Components.Schemas.MilesBrokerCompaniesData) => void;
  selectedCompany: DealerIntegration.Components.Schemas.MilesBrokerCompaniesData | undefined;
}

const mapToValue = (
  company: DealerIntegration.Components.Schemas.MilesBrokerCompaniesData
): SearchableSelectOption => ({
  key: company.milesBerCode!,
  value: `${company.milesBerCode} - ${company?.brand?.name}`,
});

export const OutletSearchCombobox: FunctionComponent<OutletSearchComboboxProps> = (props) => {
  const [value, setValue] = useState<SearchableSelectOption[]>([]);
  const { t } = useTranslation();

  useEffect(() => {
    setValue(props.selectedCompany ? [mapToValue(props.selectedCompany)] : []);
  }, [props.selectedCompany]);

  return (
    <SearchableSelect
      id="outlet-search-combobox"
      name="outlet-search-combobox"
      noOptionsMessage={t('outletSearchCombobox:searchList:noOptionsMessage')}
      value={value}
      onChange={(value) => {
        if (value.length) {
          const lastSelectedValue = value[value.length - 1];
          const company = props.allowedCompanies.find((company) => company.milesBerCode === lastSelectedValue.key);

          if (company) {
            props.onSelectedCompanyChange(company);
            setValue([mapToValue(company)]);
          }
        } else {
          setValue([]);
        }
      }}
      options={props.allowedCompanies.map((company) => mapToValue(company))}
      placeholder={t('outletSearchCombobox:searchList:placeholder')}
      searchInputLabel={t('outletSearchCombobox:searchList:searchInputLabel')}
    />
  );
};
